<ng-container *transloco="let t">
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <h1>{{ t('common.labels.appointments') }}</h1>
        <app-loader [loading]="loading"></app-loader>

        <ng-container *ngIf="loading !== true">
          <form (submit)="onSubmit()" novalidate>
            <div class="p-text-right p-mb-4">
                <button *ngIf="inEdit !== true" pButton [label]="t('common.labels.edit')" (click)="onEdit()" class="p-button-sm"></button>
                <app-form-buttons *ngIf="inEdit === true" [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
            </div>
            <app-appointment-calendar
              [type]="AppointmentCalendarType.Dates"
              [inEdit]="inEdit"
              [days]="days"
              [min]="setup?.min"
              [max]="setup?.max"
              [states]="setup?.states"
              [maxMonths]="setup?.maxMonths"
              (onDayChange)="onDayChange($event)"
            ></app-appointment-calendar>
            <app-appointment-list
              [inEdit]="inEdit"
              [days]="days"
              (onDayChange)="onDayChange($event)"
            ></app-appointment-list>
          </form>
        </ng-container>

      </div>
    </div>
  </div>
</ng-container>
